import React from 'react';

const SettingsHeader = () => {
  return (
    <div className="text-center mb-12 transform transition-all duration-500 ease-out">
      <h1 className="text-4xl font-bold text-gray-900 mb-4 animate-fade-in">
        Profile Settings
      </h1>
      <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed animate-fade-in-up">
        Manage your personal information, professional details, and account security settings
      </p>
    </div>
  );
};

export default SettingsHeader;